import { closeDialog, updateDialog } from '@Containers/Dialogs/DialogsActions';
import { resetPasswordWithToken as authResetPasswordWithToken } from '@Services/Auth/AuthResetPassword';
import Catalyst from '@Services/Catalyst';

import {
  resetPasswordWithTokenDialogSetConfirmationPasswordReducerType,
  resetPasswordWithTokenDialogSetResponseStatusReducerType,
  resetPasswordWithTokenDialogSetNewPasswordReducerType,
  typeOfResetPasswordWithTokenDialog,
  RESPONSE_STATUS,
} from './ResetPasswordWithTokenDialogConstants';

import {
  confirmationPassword as confirmationPasswordSelector,
  newPassword as newPasswordSelector,
} from './ResetPasswordWithTokenDialogSelectors';

export const openResetPasswordWithTokenDialog = (props) => (dispatch) => {
  dispatch(
    updateDialog({
      id: typeOfResetPasswordWithTokenDialog,
      dialogType: typeOfResetPasswordWithTokenDialog,
      ...props,
    })
  );
};

export const closeResetPasswordWithTokenDialog = () => (dispatch) =>
  dispatch(
    closeDialog({
      id: typeOfResetPasswordWithTokenDialog,
    })
  );

export function trackAdobeAnalyticsError(errors, prefix) {
  if (errors && errors.length) {
    errors.forEach((error) =>
      Catalyst.trackError(
        {
          message: error,
          component: 'Reset password',
        },
        prefix
      )
    );
  }
}

export function setResponseStatus(responseStatus) {
  return {
    type: resetPasswordWithTokenDialogSetResponseStatusReducerType,
    payload: { responseStatus },
  };
}

export function setNewPassword(newPassword) {
  return {
    type: resetPasswordWithTokenDialogSetNewPasswordReducerType,
    payload: { newPassword },
  };
}

export function setConfirmationPassword(confirmationPassword) {
  return {
    type: resetPasswordWithTokenDialogSetConfirmationPasswordReducerType,
    payload: { confirmationPassword },
  };
}

export const submit = (token) => async (dispatch, getState) => {
  const newPassword = newPasswordSelector(getState());
  const confirmationPassword = confirmationPasswordSelector(getState());

  if (!(newPassword.value && confirmationPassword.value) || !(newPassword.isValid && confirmationPassword.isValid)) {
    return;
  }

  dispatch(setResponseStatus(RESPONSE_STATUS.LOADING));

  await authResetPasswordWithToken(token, newPassword.value)
    .then(() => {
      dispatch(setResponseStatus(RESPONSE_STATUS.SUCCESS));
    })
    .catch((error) => {
      Logger.error(error);
      dispatch(setResponseStatus(RESPONSE_STATUS.ERROR));
    });
};
